import { SVGProps, Ref, forwardRef } from 'react';

export const UserDoubleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.353 7.5c0-2.75 1.375-5.5 5.5-5.5s5.5 2.75 5.5 5.5-1.375 5.5-5.5 5.5-5.5-2.75-5.5-5.5M17.707 22c-.809-5.202-4.831-7-8.854-7S.81 16.798 0 22zm-3.638-9.068q.245-.236.464-.498c1.213-1.456 1.62-3.292 1.62-4.934s-.407-3.478-1.62-4.934a6 6 0 0 0-.464-.498A8 8 0 0 1 15.143 2c4.125 0 5.5 2.75 5.5 5.5s-1.375 5.5-5.5 5.5q-.57-.001-1.074-.068M19.53 22h4.468c-.791-5.087-4.654-6.918-8.586-6.997 2.42 1.612 3.68 4.186 4.117 6.997"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserDoubleFilledSize24Glyph.displayName = 'UserDoubleFilledSize24Glyph';
